export function getDesignLayoutForUnitPlan(plan) {
  console.log({plan})
  return plan.design_layout || plan.unit_type_level?.design_layouts.filter((d) => d.main_vendor.id === plan.vendor.id).find((d) => d.models.length > 0)
}
